jQuery(function(){

  function outputHTMLForArticles(parent, researcherID, json, xml, img){
    var INDEX_NAME = 18;

    var firstname = json[INDEX_NAME]['http://www.w3.org/2006/vcard/ns#givenName'][0]["@value"];
    var lastname = json[INDEX_NAME]['http://www.w3.org/2006/vcard/ns#familyName'][0]["@value"];
    var imgSrc = img ? img : "http://brighterworld.mcmaster.ca/wp-content/themes/child-brighter/theme-images/researcher-default.jpg"
    var title = $($(xml).contents()).find("vcard\\:title").text();
    var profile = 'https://experts.mcmaster.ca/display/' + researcherID;
    var fullname = firstname + " " + lastname;

    $("<div></div>")
    .addClass("researcher-card")
    .appendTo(parent)
    .append(
      $("<div></div>")
      .addClass("researcher-image-outer")
      .append(
        $("<div></div>")
        .addClass("researcher-image")
        .append(
          $("<img />")
          .attr("src", imgSrc)
          .attr("alt", fullname)
        )
      )
    )
    .append(
      $("<div></div>")
      .addClass("researcher-text")
      .append(
        $("<span></span>")
        .addClass("researcher-name")
        .text( fullname)
      )
      .append(
        $("<span></span>")
        .addClass("researcher-title")
        .text( title )
      )
      .append("<hr />")
      .append(
        $("<span></span>")
        .addClass("researcher-profile-link")
        .append(
          $("<a></a>")
          .attr("href", profile)
          .attr("target", "_blank")
          .text("SEE PROFILE")
        )
      )
    )
  }

  function outputHTMLForHome(parent, researcherID, json, xml, img){
    var INDEX_NAME = 18;

    var firstname = json[INDEX_NAME]['http://www.w3.org/2006/vcard/ns#givenName'][0]["@value"];
    var lastname = json[INDEX_NAME]['http://www.w3.org/2006/vcard/ns#familyName'][0]["@value"];
    var imgSrc = img ? img : "http://brighterworld.mcmaster.ca/wp-content/themes/child-brighter/theme-images/researcher-default.jpg"
    var title = $($(xml).contents()).find("vcard\\:title").text();
    var profile = 'https://experts.mcmaster.ca/display/' + researcherID;

    $("<div></div>")
    .addClass("large-3 cell profile-background mobile-slide")
    .appendTo(parent)
    .append(
      $("<h3></h3>")
      .addClass("researcher-name")
      .text(firstname + " " + lastname)
    )
    .append(
      $("<p></p>")
      .addClass("position")
      .text(title)
    )
    .append(
      $("<p></p>")
      .addClass("description")
    )
    .append( $("<hr />"))
    .append(
      $("<a></a>")
      .addClass("read-story-button see-profile")
      .attr("href", profile)
      .append(
        $("<span></span>")
        .addClass("readmore")
        .text("See Profile")
        .append(
          $("<span></span>")
          .addClass("readmore-arrow icon-right-open")
        )
      )
    )
    .append(
      $("<a></a>")
      .attr("href", profile)
      .append(
        $("<img />")
        .addClass("profile-image")
        .attr("src", imgSrc)
        .attr("alt", firstname + " " + lastname)
      )
    )
  }

  var $ = jQuery;

  var researcherDiv;

  var articleResearchersDiv = jQuery("#article-researchers");
  var homeResearchersDiv = jQuery("#home-researchers");

  if ( articleResearchersDiv.length == 1){
    researcherDiv = articleResearchersDiv;
  }
  else if ( homeResearchersDiv.length == 1 ){
    researcherDiv = homeResearchersDiv;
  }
  else{
    return;
  }
  var researcherIDs = researcherDiv.data("researchers").split(",");

  var researcherCalls = researcherIDs.map( function(researcherID) {
    var displayURL = "https://experts.mcmaster.ca/display/vcardname-" + researcherID + "?format=json";
    var individualURL = "https://experts.mcmaster.ca/individual/vcardtitle-" + researcherID + "/vcardtitle-" + researcherID + ".rdf";
    var imageURL = "https://experts.mcmaster.ca/individual/" + researcherID + "-imageDownload";
    var deferredDisplay = $.Deferred();
    var deferredIndividual = $.Deferred();
    var deferredImage = $.Deferred();

    var display = function(){
      $.ajax({
        url: displayURL,
        success: function(data){
          deferredDisplay.resolve(data);
        },
        error: function(error){
          deferredDisplay.reject(error);
        }
      })

      return deferredDisplay.promise();
    };
    var individual = function(){
      $.ajax({
        url: individualURL,
        success: function(data){
          deferredIndividual.resolve(data);
        },
        error: function(error){
          deferredIndividual.reject(error);
        }
      })

      return deferredIndividual.promise();
    };
    var image = function(){
      $.ajax({
        url: imageURL,
        success: function(data){
          deferredImage.resolve(data);
        },
        error: function(error){
          deferredImage.reject(error);
        }
      })

      return deferredImage.promise()
      .then(function(){ return imageURL; });
    };

    $.when(display(), individual()).done(function(json, xml){

      // Handling if the researcher has a profile picture or not
      $.when(image())
      .then( function(img) {
        if (homeResearchersDiv.length == 1){
          outputHTMLForHome(researcherDiv, researcherID, json, xml, imageURL);
        }
        else{
          outputHTMLForArticles(researcherDiv, researcherID, json, xml, imageURL);
        }
      }, function(error){
        if (homeResearchersDiv.length == 1){
          outputHTMLForHome(researcherDiv, researcherID, json, xml, null);
        }
        else{
          outputHTMLForArticles(researcherDiv, researcherID, json, xml, null);
        }
      })
    });

  });




});
